import type { Article } from "@/types";

export const articles: Article[] = [
  {
    slug: "top-star-late-night-shoot-rumor",
    title: "某顶流男星深夜片场路透曝光，同组女演员全程同行引热议",
    excerpt:
      "一条深夜收工路透把两位主演再次送上热搜。剧组知情人透露两人只是顺路，但同款保温杯和同色系外套让瓜友直呼离谱。",
    category: "star",
    categoryName: "明星八卦",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20warm-toned%20abstract%20image%20of%20a%20night%20film%20set%20with%20dramatic%20spotlights%2C%20silhouettes%20of%20film%20equipment%2C%20deep%20amber%20and%20coral%20lighting%2C%20film%20grain%2C%20moody%20high%20contrast%2C%20editorial%20photography%2C%20no%20visible%20faces&width=1200&height=800&seq=bg-art-01&orientation=landscape",
    author: "瓜田观察员",
    date: "2026-09-10",
    readTime: "6 分钟",
    views: 186420,
    tags: ["顶流", "路透", "片场", "热搜"],
    hot: true,
    content: [
      {
        type: "p",
        text: "一条只有十几秒的深夜路透，在凌晨两点把话题顶上了热搜前排。画面里，某位常年霸榜的顶流男星收工后从片场侧门走出，同组女演员紧随其后，两人一前一后上了同一辆车。",
      },
      {
        type: "p",
        text: "爆料账号配文只有一句话：这已经不是第一次了。评论区瞬间炸开，有人翻出两人三个月前同款外套的机场图，也有人表示同组演员一起收工再正常不过，没必要过度解读。",
      },
      { type: "h2", text: "剧组知情人：只是顺路，车是剧组统一安排的" },
      {
        type: "p",
        text: "我们联系到一位要求匿名的剧组工作人员。对方表示，拍摄地偏僻，收工时间又晚，剧组通常会安排商务车统一送演员回酒店，所谓同车其实只是后勤安排，并非外界想象的剧情。",
      },
      {
        type: "quote",
        text: "真要有什么事，也不会大摇大摆从正门走，大家想多了。",
      },
      {
        type: "p",
        text: "有意思的是，网友的注意力很快从同车转移到了同款保温杯上。有细心的瓜友发现，两人最近三次公开露面的水杯是同一个小众联名款，连贴纸位置都对得上。这个细节让原本打算息事宁人的粉丝又坐不住了。",
      },
      { type: "h2", text: "工作室回应：不回应私事，专注作品" },
      {
        type: "p",
        text: "截至发稿，男星工作室并未发布正式声明，仅在粉丝群里回复了一句不评价私人行程。女演员方面则保持了沉默。这种集体冷处理的态度，在吃瓜群众看来反而更有想象空间。",
      },
      {
        type: "p",
        text: "需要提醒的是，路透画面本就模糊，同款单品在剧组的日常使用中也并不罕见。在当事人给出明确说明之前，把推测当作事实，对谁都算不上公平。",
      },
    ],
  },
  {
    slug: "singer-album-delay-backstage",
    title: "新专辑延期三个月，歌手背后的制作风波被前团队成员揭开",
    excerpt:
      "原定六月上线的新专辑一拖再拖，前制作团队成员发文讲述录音棚里发生的事情，把这场延期背后的分歧摆到了台面上。",
    category: "star",
    categoryName: "明星八卦",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20warm-toned%20abstract%20recording%20studio%20interior%20with%20vintage%20microphone%2C%20soft%20amber%20light%2C%20dusty%20atmosphere%2C%20film%20grain%2C%20shallow%20depth%20of%20field%2C%20editorial%20mood%2C%20no%20visible%20faces&width=1200&height=800&seq=bg-art-02&orientation=landscape",
    author: "录音棚街探",
    date: "2026-09-09",
    readTime: "7 分钟",
    views: 97310,
    tags: ["专辑", "制作", "延期", "团队"],
    hot: true,
    content: [
      {
        type: "p",
        text: "从六月等到九月，歌迷口中的新专辑终于有了新动静，只不过这次不是预告,而是一篇来自前团队成员的长文。文章没有指名道姓，但字里行间透露的信息量足够把整个延期原因串起来。",
      },
      { type: "h2", text: "问题出在选歌还是出在人" },
      {
        type: "p",
        text: "根据这篇长文的说法，专辑的曲目在最后阶段经历了大规模调整。原本已经完成混音的四首歌被临时撤下，理由是风格不够统一。这个决定让不少已经投入大量精力的制作人感到挫败。",
      },
      {
        type: "quote",
        text: "我们不是不能改，是改到第八版的时候，已经不知道自己在改什么了。",
      },
      {
        type: "p",
        text: "文中还提到，团队内部对主打歌的方向存在明显分歧：一部分人希望延续上一张专辑的抒情路线，另一部分则坚持尝试更激进的电子元素。双方各执一词，最终导致项目进度停滞。",
      },
      { type: "h2", text: "行业里其实很常见" },
      {
        type: "p",
        text: "需要说明的是，专辑延期在音乐行业并非罕见现象。创作型歌手对作品的反复打磨，往往意味着更高的完成度，也意味着更长的等待。把延期简单归咎于某一个人，并不客观。",
      },
      {
        type: "p",
        text: "对歌迷来说，与其纠结谁对谁错，不如把期待留到专辑真正上线的那一天。毕竟能不能打动耳朵，最终还是要用户听了才算数。",
      },
    ],
  },
  {
    slug: "livestream-selloff-refund-wave",
    title: "直播间三小时售罄后遭遇退款潮，这场带货翻车到底翻在哪里",
    excerpt:
      "开播三小时销售额破纪录，随后却迎来大规模退款。复盘这场直播，货品、话术和售后三个环节都埋着雷。",
    category: "influencer",
    categoryName: "网红黑料",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20warm-toned%20abstract%20image%20of%20a%20bright%20livestream%20studio%20setup%20with%20ring%20lights%20and%20parcels%2C%20amber%20and%20red%20lighting%2C%20film%20grain%2C%20editorial%20moody%20composition%2C%20no%20visible%20faces&width=1200&height=800&seq=bg-art-03&orientation=landscape",
    author: "带货风向台",
    date: "2026-09-09",
    readTime: "6 分钟",
    views: 142880,
    tags: ["直播带货", "退款", "翻车", "售后"],
    hot: true,
    content: [
      {
        type: "p",
        text: "这场直播的数据一度被同行当作案例研究：开播十分钟在线人数破百万，三小时后主推商品宣告售罄。可热闹只持续了一个晚上，第二天后台的退款率就开始一路走高。",
      },
      { type: "h2", text: "货不对板是退款的第一推手" },
      {
        type: "p",
        text: "多位买家反馈，直播间展示的样品与收到的实物在材质上有明显出入。虽然商家强调属于不同批次，但直播间反复出现的同款展示，已经在消费者心里建立了一个明确的预期。",
      },
      {
        type: "quote",
        text: "主播说这个价位闭眼入，结果拆开包裹那一刻我就后悔了。",
      },
      { type: "h2", text: "话术的边界在哪里" },
      {
        type: "p",
        text: "复盘直播回放可以发现，主播多次使用绝对化表述，比如全网最低、错过再等一年。这类话术短期内确实能刺激下单，但一旦商品体验跟不上，反噬的速度同样惊人。",
      },
      {
        type: "p",
        text: "更值得关注的是售后环节。有买家表示，申请退款时客服多次以活动价不退不换为由拒绝，直到平台介入才完成处理。售后体验的塌方，往往才是压垮口碑的最后一根稻草。",
      },
      {
        type: "p",
        text: "直播带货本质上是信任生意。货品扎实、话术克制、售后利落，三件事任何一件掉链子，翻车都只是时间问题。",
      },
    ],
  },
  {
    slug: "influencer-account-vanish-mystery",
    title: "百万粉账号一夜清空作品，账号风波背后是谁的决定",
    excerpt:
      "前一天还在更新日常，第二天主页只剩下一行简介。粉丝群里众说纷纭，我们把能确认的信息整理了出来。",
    category: "influencer",
    categoryName: "网红黑料",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20warm-toned%20abstract%20image%20of%20a%20dark%20phone%20screen%20glow%20on%20a%20desk%20with%20scattered%20screens%2C%20amber%20and%20deep%20red%20tones%2C%20film%20grain%2C%20editorial%20moody%20lighting%2C%20no%20visible%20faces&width=1200&height=800&seq=bg-art-04&orientation=landscape",
    author: "账号观察站",
    date: "2026-09-08",
    readTime: "5 分钟",
    views: 76540,
    tags: ["账号", "清空", "MCN", "合约"],
    hot: false,
    content: [
      {
        type: "p",
        text: "事情发生得很突然。一位拥有百万粉丝的博主，在没有任何预兆的情况下清空了全部作品，只留下简介里一句简短的谢谢陪伴。",
      },
      { type: "h2", text: "三种流传最广的说法" },
      {
        type: "p",
        text: "目前网络上主要有三种说法：一是与所属机构产生了合约分歧；二是本人想转型做新的内容方向；三是单纯的阶段性休息。三种说法都没有得到当事人确认。",
      },
      {
        type: "quote",
        text: "做内容的人，最怕的不是没流量，而是流量和自己的想法拧着走。",
      },
      {
        type: "p",
        text: "值得注意的是，该博主的作品并未被平台下架，账号本身也处于正常状态。这意味着清空更像是主动行为，而不是被动处理。这一点，让合约分歧的说法显得更有说服力。",
      },
      {
        type: "p",
        text: "无论原因是什么，内容创作者的职业选择都值得被尊重。在信息没有落地之前，保持基本的克制，是对当事人最好的体面。",
      },
    ],
  },
  {
    slug: "metro-seat-argument-viral",
    title: "地铁让座争执视频刷屏，我们在评论区看到了两种截然不同的态度",
    excerpt:
      "一段两分钟的争执视频引发全网讨论，有人指责年轻人冷漠，也有人喊话说这届乘客已经被道德绑架怕了。",
    category: "society",
    categoryName: "社会热点",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20warm-toned%20abstract%20image%20of%20a%20subway%20car%20interior%20bathed%20in%20amber%20light%2C%20blurred%20motion%2C%20film%20grain%2C%20documentary%20style%2C%20editorial%20mood%2C%20no%20visible%20faces&width=1200&height=800&seq=bg-art-05&orientation=landscape",
    author: "现场编辑",
    date: "2026-09-08",
    readTime: "6 分钟",
    views: 221300,
    tags: ["让座", "公共空间", "讨论", "城市"],
    hot: true,
    content: [
      {
        type: "p",
        text: "两分钟的视频，短短一天播放量破千万。画面记录的是地铁车厢里因为一个座位引发的争执，双方情绪都不算平静。",
      },
      { type: "h2", text: "同一个画面，两种解读" },
      {
        type: "p",
        text: "评论区几乎自动分成了两派。一派认为年轻人理应主动让座，这是基本的公共礼仪；另一派则指出，视频里并没有明确的特殊标识，不能默认所有人都必须起身。",
      },
      {
        type: "quote",
        text: "让座是美德，不是义务。把美德当成规定，美德就变了味。",
      },
      { type: "h2", text: "规则之外，还有理解" },
      {
        type: "p",
        text: "公共交通的座位资源本就紧张，早晚高峰更是如此。与其在道德层面互相指责，不如把讨论拉回到更实际的问题上：车厢内的爱心座位标识是否足够清晰，站台广播是否做到了有效提示。",
      },
      {
        type: "p",
        text: "一个健康的公共空间，既需要愿意让座的人，也需要愿意体谅他人疲惫的人。争论本身不是坏事，怕的是把复杂的问题简化成非黑即白。",
      },
    ],
  },
  {
    slug: "community-group-buy-dispute",
    title: "小区团购货损谁来担，一场拉锯战暴露了社区团购的老问题",
    excerpt:
      "团购的生鲜到货一半不新鲜，团长、平台、居民三方各执一词。这场最常见的纠纷，其实有更简单的解法。",
    category: "society",
    categoryName: "社会热点",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20warm-toned%20abstract%20image%20of%20grocery%20boxes%20at%20a%20community%20pickup%20point%2C%20warm%20amber%20daylight%2C%20film%20grain%2C%20documentary%20editorial%20style%2C%20no%20visible%20faces&width=1200&height=800&seq=bg-art-06&orientation=landscape",
    author: "社区观察",
    date: "2026-09-07",
    readTime: "5 分钟",
    views: 58420,
    tags: ["社区团购", "售后", "邻里", "生鲜"],
    hot: false,
    content: [
      {
        type: "p",
        text: "事情的起因很简单：一批团购的绿叶菜到货时已经有明显腐烂，居民要求退货，团长表示损耗是运输环节造成的，平台则把责任指向了分拣。",
      },
      { type: "h2", text: "责任链条为什么难厘清" },
      {
        type: "p",
        text: "社区团购的链路很长：产地、分拣、干线运输、最后一百米。任何一环出问题，最终都会体现在居民收到的货上，但追责时每一环又都能找到看似合理的说法。",
      },
      {
        type: "quote",
        text: "团长夹在中间最难受，一边是邻居，一边是平台。",
      },
      {
        type: "p",
        text: "实际上，多数平台对生鲜品类都有明确的货损赔付规则，只是规则往往藏在冗长的条款里，普通用户并不清楚。团长如果能在下单前把规则同步给居民，很多争执在源头就能避免。",
      },
      {
        type: "p",
        text: "邻里之间的团购，本质上靠的是熟人信任。把规则讲在前面，把售后做在明处，才能让这份信任走得更远。",
      },
    ],
  },
  {
    slug: "drama-finale-editing-controversy",
    title: "热播剧大结局引发两极评价，剪辑刀口下的叙事到底差在哪",
    excerpt:
      "追了三十集的观众在结局夜集体失眠。有人哭着打五星，有人直接弃剧，争议的焦点落在了最后两集的剪辑上。",
    category: "screen",
    categoryName: "影视综艺",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20warm-toned%20abstract%20image%20of%20a%20cinema%20screen%20with%20amber%20projector%20light%20and%20dust%20particles%2C%20deep%20red%20tones%2C%20film%20grain%2C%20editorial%20mood%2C%20no%20visible%20faces&width=1200&height=800&seq=bg-art-07&orientation=landscape",
    author: "追剧情报组",
    date: "2026-09-07",
    readTime: "7 分钟",
    views: 128760,
    tags: ["大结局", "剪辑", "剧评", "口碑"],
    hot: true,
    content: [
      {
        type: "p",
        text: "从开播到收官，这部剧一直在热搜上。真正让讨论达到顶点的，是最后两集播出后的那个夜晚。",
      },
      { type: "h2", text: "节奏断裂是最大的痛点" },
      {
        type: "p",
        text: "不少观众反馈，前三十集的叙事节奏稳、铺垫足，人物动机也立得住。但到了最后两集，多条支线被快速收束，几位配角的故事线几乎在一场戏里草草交代，观感上像是被按了快进键。",
      },
      {
        type: "quote",
        text: "不是不能开放式结局，是前面埋的线得有人捡起来。",
      },
      { type: "h2", text: "演员的表演撑住了口碑底线" },
      {
        type: "p",
        text: "抛开节奏问题，几位主演在结局里的情绪处理依然在线。尤其是最后一场对手戏，台词不多，但靠眼神完成了信息传递，弹幕里齐刷刷的破防也说明了观众并非不买账。",
      },
      {
        type: "p",
        text: "一部剧的结局很难让所有人满意。对创作者来说，如何在有限的篇幅里完成情感的闭环，永远是最难的一课。",
      },
    ],
  },
  {
    slug: "variety-show-editing-shade",
    title: "综艺镜头分配再引争议，被剪掉的十分钟里藏着什么",
    excerpt:
      "新一期综艺播出后，某位嘉宾的镜头时长被粉丝反复统计。这已经不是第一次因为剪辑分配而掀起讨论。",
    category: "screen",
    categoryName: "影视综艺",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20warm-toned%20abstract%20image%20of%20a%20tv%20studio%20set%20with%20warm%20amber%20stage%20lights%20and%20empty%20chairs%2C%20film%20grain%2C%20editorial%20mood%2C%20no%20visible%20faces&width=1200&height=800&seq=bg-art-08&orientation=landscape",
    author: "综艺观察台",
    date: "2026-09-06",
    readTime: "5 分钟",
    views: 63210,
    tags: ["综艺", "剪辑", "镜头", "嘉宾"],
    hot: false,
    content: [
      {
        type: "p",
        text: "播出当晚，社交平台上就出现了大量真人逐帧统计的帖子。结论很一致：某位嘉宾在整期节目中的有效镜头不足两分钟。",
      },
      { type: "h2", text: "镜头分配是综艺的老难题" },
      {
        type: "p",
        text: "一档综艺成片通常只有九十分钟到一个小时，录制素材却可能长达十几个小时。如何在有限的时间里平衡嘉宾曝光、节目节奏和观众喜好，本身就是一道没有标准答案的题。",
      },
      {
        type: "quote",
        text: "镜头少不等于被针对，但观众的情绪也需要一个出口。",
      },
      {
        type: "p",
        text: "从节目组的角度看，剪辑的核心目标是服务叙事节奏。有些嘉宾性格偏安静，即便录制时说了很多，也未必能剪进成片。但从观众角度看，既然请来了人，给足基本的呈现空间，也是另一种尊重。",
      },
      {
        type: "p",
        text: "也许更值得讨论的，是综艺行业需要更透明的沟通方式，而不是每一次都让观众靠数镜头来表达诉求。",
      },
    ],
  },
  {
    slug: "long-distance-relationship-reality",
    title: "异地恋第三年，她终于说出了那句攒了很久的话",
    excerpt:
      "一段被朋友圈羡慕的异地恋，在第三个年头走到了岔路口。这不是谁对谁错的问题，而是两个人对未来的想象出了偏差。",
    category: "emotion",
    categoryName: "情感吐槽",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20warm-toned%20abstract%20image%20of%20a%20phone%20screen%20light%20on%20a%20night%20windowsill%20with%20rain%2C%20amber%20and%20coral%20tones%2C%20film%20grain%2C%20intimate%20editorial%20mood%2C%20no%20visible%20faces&width=1200&height=800&seq=bg-art-09&orientation=landscape",
    author: "情感编辑室",
    date: "2026-09-06",
    readTime: "6 分钟",
    views: 88940,
    tags: ["异地恋", "关系", "沟通", "现实"],
    hot: false,
    content: [
      {
        type: "p",
        text: "她的朋友圈一直很甜：纪念日的转账、深夜的语音、跨城的机票截图。直到某个普通的周二，她发了一条没有配图的状态，说自己累了。",
      },
      { type: "h2", text: "问题不在距离，在时间表" },
      {
        type: "p",
        text: "聊了很久之后才明白，真正让她动摇的不是距离本身，而是两个人对何时结束异地、在哪个城市定居，始终没能给出一个明确的答案。三年里，这个话题被一次次推迟。",
      },
      {
        type: "quote",
        text: "我不怕等，我怕的是等一个不会到来的计划。",
      },
      { type: "h2", text: "把模糊的承诺变成具体的节点" },
      {
        type: "p",
        text: "很多异地关系走不到最后，并不是因为感情不够，而是因为未来太过抽象。心理学上有个被反复验证的观点：把大的目标拆成有时间的节点，能显著降低关系中的焦虑感。",
      },
      {
        type: "p",
        text: "比如把以后再说，换成明年三月我来你的城市实习。一句具体的话，抵得过一百次我想你。",
      },
    ],
  },
  {
    slug: "friend-loan-turns-awkward",
    title: "借给朋友的三万块，成了我们之间最后的话题",
    excerpt:
      "借钱时是兄弟，催款时成了陌生人。一个再普通不过的故事，却几乎每个人都能对上号。",
    category: "emotion",
    categoryName: "情感吐槽",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20warm-toned%20abstract%20image%20of%20a%20coffee%20table%20with%20two%20cups%20and%20a%20blurred%20phone%2C%20warm%20amber%20daylight%2C%20film%20grain%2C%20editorial%20mood%2C%20no%20visible%20faces&width=1200&height=800&seq=bg-art-10&orientation=landscape",
    author: "人间观察簿",
    date: "2026-09-05",
    readTime: "5 分钟",
    views: 71230,
    tags: ["借钱", "友情", "边界", "沟通"],
    hot: false,
    content: [
      {
        type: "p",
        text: "三年前的那句先借我周转一下，他还记得清清楚楚。当时没打借条，也没说具体什么时候还，因为他觉得，朋友之间谈这个太见外。",
      },
      { type: "h2", text: "友情和金钱的边界" },
      {
        type: "p",
        text: "真正让关系变味的，往往不是钱本身，而是催款时的那份尴尬。开口怕伤感情，不开口又心里别扭，时间一长，见面都变得不自然。",
      },
      {
        type: "quote",
        text: "借钱考验的不是对方的诚信，是你敢不敢把规则说在前面。",
      },
      {
        type: "p",
        text: "很多关系研究者都建议，涉及金额较大的借贷时，把还款时间写清楚，反而是对友情的保护。模糊的承诺会随着时间发酵成怨气，清晰的约定才能让双方都松一口气。",
      },
      {
        type: "p",
        text: "如果一笔钱已经让一段关系变得小心翼翼，那它带来的损失，早就超过了金额本身。",
      },
    ],
  },
  {
    slug: "idol-fan-meeting-cancel",
    title: "粉丝见面会临时取消，退票方案公布后粉丝反应出乎意料",
    excerpt:
      "距离见面会还有三天，主办方突然宣布取消。本以为会引发大规模不满，结果公布退票方案后，讨论的风向转了。",
    category: "star",
    categoryName: "明星八卦",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20warm-toned%20abstract%20image%20of%20an%20empty%20concert%20hall%20with%20warm%20amber%20stage%20light%20and%20seats%2C%20film%20grain%2C%20editorial%20mood%2C%20no%20visible%20faces&width=1200&height=800&seq=bg-art-11&orientation=landscape",
    author: "演出情报局",
    date: "2026-09-05",
    readTime: "5 分钟",
    views: 55480,
    tags: ["见面会", "退票", "演出", "粉丝"],
    hot: false,
    content: [
      {
        type: "p",
        text: "取消公告发布在晚上十点，措辞很简短，理由是场地档期出现变动。消息一出，评论区立刻被疑问和担忧填满。",
      },
      { type: "h2", text: "退票方案的诚意是关键" },
      {
        type: "p",
        text: "第二天中午，主办方公布了完整的处理方案：全额退票之外，还承担了异地粉丝的部分交通补贴申请。正是这一条，让原本准备开骂的观众冷静了下来。",
      },
      {
        type: "quote",
        text: "演出取消可以理解，但态度好不好，一眼就能看出来。",
      },
      {
        type: "p",
        text: "大型演出的取消往往牵涉多方，很多时候主办方也是被动的一方。真正拉开差距的，是在突发状况发生后，愿不愿意把观众的损失放在心上。",
      },
      {
        type: "p",
        text: "这场风波最终没有演变成公关危机，恰恰说明了一个朴素道理：诚意，是最好的危机公关。",
      },
    ],
  },
  {
    slug: "skincare-brand-hype-review",
    title: "被吹上天的平价面霜，一周实测后我决定说点实话",
    excerpt:
      "全网都在推的那款面霜，价格确实友好，但效果是不是传说中那么神？我们做了一次不太严谨但足够诚实的实测。",
    category: "influencer",
    categoryName: "网红黑料",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20warm-toned%20abstract%20image%20of%20skincare%20jars%20on%20a%20beige%20linen%20surface%20with%20soft%20amber%20light%2C%20minimal%20editorial%20photography%2C%20film%20grain%2C%20no%20visible%20faces&width=1200&height=800&seq=bg-art-12&orientation=landscape",
    author: "好物较真组",
    date: "2026-09-04",
    readTime: "6 分钟",
    views: 93150,
    tags: ["测评", "护肤", "带货", "真实体验"],
    hot: false,
    content: [
      {
        type: "p",
        text: "朋友圈、短视频、带货直播间，几乎在同一时间被同一款面霜占领。宣传语很统一：大牌同款成分，价格只要三分之一。",
      },
      { type: "h2", text: "成分表不会说谎" },
      {
        type: "p",
        text: "把成分表逐个对比之后可以发现，核心保湿成分的确相似，但排在配方表靠后位置的有效物浓度，与宣传中的大牌并不完全对等。这不代表它没效果，只是没那么神。",
      },
      {
        type: "quote",
        text: "平价有好货，但平价不等于同等浓度。",
      },
      { type: "h2", text: "一周实测的结论" },
      {
        type: "p",
        text: "干皮同事使用后反馈保湿感在线，夜间涂抹第二天上妆服帖；油皮同事则觉得略有厚重，夏季使用会有轻微闷感。个体差异，在护肤这件事上尤为明显。",
      },
      {
        type: "p",
        text: "如果把它定位成一款价格友好的日常保湿霜，它是合格的；但如果抱着替代高端线的期待去买，大概率会失望。理性种草，永远比盲目跟风划算。",
      },
    ],
  },
  {
    slug: "overtime-culture-young-workers",
    title: "年轻人开始准点下班，办公室里的气氛悄悄变了",
    excerpt:
      "一批新人准时打卡走人，不加班、不陪聊，也没有任何解释。这种变化，正在重新定义职场里的潜规则。",
    category: "society",
    categoryName: "社会热点",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20warm-toned%20abstract%20image%20of%20an%20office%20desk%20at%20dusk%20with%20warm%20amber%20lamp%20glow%20and%20closed%20laptop%2C%20film%20grain%2C%20editorial%20mood%2C%20no%20visible%20faces&width=1200&height=800&seq=bg-art-13&orientation=landscape",
    author: "职场记录仪",
    date: "2026-09-04",
    readTime: "6 分钟",
    views: 168920,
    tags: ["职场", "加班", "边界", "文化"],
    hot: true,
    content: [
      {
        type: "p",
        text: "在某互联网公司的开放工区里，晚上七点半的座位比过去空了很多。准时离开的，大多是入职不到两年的年轻人。",
      },
      { type: "h2", text: "他们不是不努力" },
      {
        type: "p",
        text: "和刻板印象不同，这批年轻人白天的工作效率往往并不低。他们把任务拆解得更清楚，沟通更直接，也更善于拒绝临时插入的非必要事项。",
      },
      {
        type: "quote",
        text: "我不是不愿意拼，我是不愿意用时长证明自己。",
      },
      { type: "h2", text: "管理者也在适应" },
      {
        type: "p",
        text: "有团队负责人坦言，最初确实有些不适应，因为过去判断员工投入度，很大程度上依赖在岗时长。当越来越多的人准点下班，管理者不得不转向看结果、看交付。",
      },
      {
        type: "p",
        text: "这场静悄悄的变化，未必能立刻改变所有行业，但它至少说明了一件事：职场规则，从来不是一成不变的。",
      },
    ],
  },
  {
    slug: "animated-film-dub-cast-backlash",
    title: "动画电影配音阵容公布，演员跨界配音为何频频引发争议",
    excerpt:
      "新片配音阵容一经公布，专业配音演员和粉丝就吵了起来。争论的背后，其实是行业分工的一次公开对话。",
    category: "screen",
    categoryName: "影视综艺",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20warm-toned%20abstract%20image%20of%20a%20recording%20booth%20window%20with%20warm%20amber%20light%20and%20headphones%2C%20film%20grain%2C%20editorial%20mood%2C%20no%20visible%20faces&width=1200&height=800&seq=bg-art-14&orientation=landscape",
    author: "影音观察",
    date: "2026-09-03",
    readTime: "6 分钟",
    views: 47760,
    tags: ["配音", "动画", "行业", "争议"],
    hot: false,
    content: [
      {
        type: "p",
        text: "一部备受期待的动画电影公布了中文配音阵容，几位影视演员的名字排在前面，专业配音演员则位列其后。名单公布不到一小时，讨论就冲上了热榜。",
      },
      { type: "h2", text: "明星配音的两难" },
      {
        type: "p",
        text: "片方邀请演员配音，看中的是宣发声量，这一点无可厚非。但动画角色对声音的表现力要求很高，仅靠知名度，很难撑起一个需要细腻情绪层次的角色。",
      },
      {
        type: "quote",
        text: "观众买票进影院，是想听角色说话，不是听明星念稿。",
      },
      {
        type: "p",
        text: "不过也有从业者持不同看法：优秀的演员往往具备扎实的台词功底，跨界配音并非全无可能。问题不在于能不能跨，而在于用不用心。",
      },
      {
        type: "p",
        text: "这场讨论真正有价值的地方，在于让更多人意识到配音是一门专业。尊重专业，行业才能产出经得起反复回味的声音。",
      },
    ],
  },
];